import * as angular from 'angular';

import { DatabaseSelector } from './select-db-connect-component';
import { getAppName, getSupportEmail } from '@mode/shared/util-js';

class DbTypeaheadSelectorController {
  readonly appName = getAppName();
  readonly intercomEmail = getSupportEmail();
  private dbList: DatabaseSelector[];
  private highlightDbLogo = false;
  private selected = '';
  private flowFromParams: string;

  static $inject = ['$window'];
  constructor(private $window: angular.IWindowService) {}

  onOpenCloseMenu() {
    this.highlightDbLogo = !this.highlightDbLogo;
  }

  redirectToDbCredentials($item) {
    this.$window.location.href = this.flowFromParams ? $item.link + '?flow=' + this.flowFromParams : $item.link;
  }
}

const DbTypeaheadSelectorComponent: angular.IComponentOptions = {
  controller: DbTypeaheadSelectorController,
  controllerAs: 'ctrl',
  bindings: {
    dbList: '<',
    flowFromParams: '<',
  },
  template: `<div class="db-typeahead-selector">
    <div class="all-db-copy">Or, search from our full list of supported databases</div>
    <ui-select
      ng-model="ctrl.selected"
      theme="bootstrap"
      uis-open-close="ctrl.onOpenCloseMenu()"
      on-select="ctrl.redirectToDbCredentials($item)"
    >
      <ui-select-match placeholder="Search databases...">{{ $select.selected.name }}</ui-select-match>
      <ui-select-choices repeat="dbChoice in (ctrl.dbList | filter: $select.search)">
         <div ng-bind-html="dbChoice.name | highlight: $select.search"></div>
      </ui-select-choices>
      <ui-select-no-choice>
        No matches found. <a href intercom-show="Hi, I'd like to request support in {{ctrl.appName}} for the following database: " intercom-email="{{ctrl.intercomEmail}}" class="intercom-link new-db-request">Request support</a> for a database type.
      </ui-select-no-choice>
    </ui-select>
  </div>`,
};

angular.module('mode.components').component('dbTypeaheadSelector', DbTypeaheadSelectorComponent);
